import { getActiveLocation } from "features/location/selectors/getLocationPermissions";
import { createSelector } from "reselect";

export const getPosName = createSelector(getActiveLocation, (activeLocation) => {
    const { posDisplayName, venuePosDisplayName } = activeLocation?.posMetadata || {};
    return venuePosDisplayName || posDisplayName || "POS";
});
